import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'formly-panel-wrapper',
  template: `
    <div class="panel panel-default">
      <div class="panel-heading">
        <h2>{{ props.label }}</h2>
      </div>
      <div class="panel-body form-grid">
        <!-- Image field -->
        <div class="image-field">
          <formly-field [field]="imageField"></formly-field>
        </div>
        <!-- Non-image fields -->
        <div class="fields-container">
          @for (field of nonImageFields; track field) {
            <formly-field [field]="field"></formly-field>
          }
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .panel-body {
        padding: 0.9375rem;
      }
      .form-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 1rem;
        align-items: start;
      }
      .image-field {
        grid-column: 1 / 2;
        grid-row: 1 / -1;
      }
      .image-field img {
        max-height: 18.75rem;
        object-fit: contain;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormlyModule],
})
export class PanelWrapperComponentV2 extends FieldWrapper {
  get imageField() {
    return this.field.fieldGroup?.find((f) => f.type === 'image') || {};
  }

  get nonImageFields() {
    return this.field.fieldGroup?.filter((f) => f.type !== 'image') || [];
  }
}
